'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _utilsGetrandomstring = require('../../utils/getrandomstring');

var _utilsGetrandomstring2 = _interopRequireDefault(_utilsGetrandomstring);

var _components = {
	_$RadioList: {
		displayName: 'RadioList'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var RadioList = (function (_Component) {
	_inherits(RadioList, _Component);

	function RadioList(props) {
		_classCallCheck(this, _RadioList);

		_Component.call(this, props);
		this.uid = _utilsGetrandomstring2['default']();
	}

	RadioList.prototype.handleChange = function handleChange(e) {
		var value = e.target.value;
		if (value) {
			value = parseInt(value);
		}

		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	};

	RadioList.prototype.render = function render() {
		var _this = this;

		var inputs = this.props.options.map(function (item) {
			return _react2['default'].createElement(
				'label',
				{ key: item.id },
				_react2['default'].createElement('input', { checked: item.id == _this.props.value,
					type: 'radio',
					value: item.id,
					name: _this.uid,
					onChange: function (e) {
						return _this.handleChange(e);
					},
					key: item.id }),
				' ',
				item.title
			);
		});

		return _react2['default'].createElement(
			'span',
			{ className: 'radiolist' },
			inputs
		);
	};

	var _RadioList = RadioList;
	RadioList = _wrapComponent('_$RadioList')(RadioList) || RadioList;
	return RadioList;
})(_Component2['default']);

exports['default'] = RadioList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/RadioListBase.js
 ** module id = 1018
 ** module chunks = 1
 **/